<div [formGroup]="form" class="flex flex-column gap-2">
  <label
    *ngIf="item.label && item.label !== ''"
    [attr.for]="item.key"
    class="font-semibold"
    >{{ item.label || '' | translate }}
    <span class="asterisk" *ngIf="item.required">*</span>
  </label>

  <input
    ngClass="{{ isInValid ? 'ng-invalid ng-dirty' : '' }}"
    pInputText
    [placeholder]="item.placeholder || '' | translate"
    [maxlength]="item.config?.maxLength || maxLength"
    [formControlName]="item.key"
    [type]="item.type"
    (keypress)="keyPress($event)"
    (paste)="paste($event)"
  />

  <ng-container *ngFor="let error of item.errorMessage | keyvalue">
    <small
      class="p-error block font-italic"
      *ngIf="isInValid && hasError(error.key)"
    >
      {{ error.value?.message || '' | translate : error.value?.params }}
    </small>
  </ng-container>
</div>
